import Media from '@model/content/Media'

class MediaFile extends Media {
    constructor(object) {
        super(object)
    }
}

export default MediaFile
